import React, { useEffect, useState } from "react";
import WinnerParticipantPanel from './winnerParticipantPanel.component';
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "modules/notification";
import moment from "moment";
import { unwrapResult } from "@reduxjs/toolkit";
import { getWinnerParticipantDatalist } from "modules/reporting/redux";

export default function WinnerParticipantPanelContainer({
    url,
    currentFilter,
    pageType,
    translate
}){
    const dispatch = useDispatch();

    const isFetchingWinnerParticipantDatalist = useSelector(state => selectLoading(state, getWinnerParticipantDatalist.typePrefix));
    const winnerParticipantDatalist = useSelector(state => state.reporting.campaign.winnerParticipantDatalist);

    const [tableFilter, setTableFilter] = useState({
        page: 0,
        rowsPerPage: 25,
        search: "",
        searchBy: "name",
        orderBy: "created_at",
        orderDirection: "desc",
    })

    useEffect(() => {
        dispatch(getWinnerParticipantDatalist({
            length: tableFilter.rowsPerPage,
            start: tableFilter.page * tableFilter.rowsPerPage,
            orderBy: tableFilter.orderBy,
            orderDirection: tableFilter.orderDirection,
            search: tableFilter.search,
            searchBy: tableFilter.searchBy,
            countryCode: currentFilter.countryCode,
            city_uuid: currentFilter.cityUuid,
            branch_uuid: currentFilter.branchUuid,
            period: currentFilter.period,
            start_date: moment(currentFilter.dateRange[0]).format('YYYY-MM-DD'),
            end_date: moment(currentFilter.dateRange[1]).format('YYYY-MM-DD'),
            prize_uuid: currentFilter.prizeUuid,
            campaign_uuid: currentFilter.campaignUuid,
            campaign_type: currentFilter.campaignType,
            url: url
        })).then(unwrapResult);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, tableFilter, currentFilter]);

    const handleChangePage = (e, newPage) => {
        setTableFilter((prev) => ({
          ...prev,
          page: newPage,
        }))
    }

    const handleChangeRowPerPage = (event) => {
        setTableFilter((prev) => ({
          ...prev,
          page: 0,
          rowsPerPage: event.target.value
        }))
    }

    const handleRequestSort = (event, property) => {
        const isAsc = tableFilter.orderBy === property && tableFilter.orderDirection === 'asc';
        setTableFilter((prev) => ({
            ...prev,
            orderDirection: isAsc ? 'desc' : 'asc',
            orderBy: property,
        }))
    }

    return (
        <WinnerParticipantPanel 
            status={{
                isFetchingWinnerParticipantDatalist,
            }}

            data={{
                winnerParticipantDatalist,
            }}

            sort={{
                valueToOrderBy: tableFilter.orderBy,
                orderDirection: tableFilter.orderDirection,
                handleRequestSort: handleRequestSort,
            }}

            pagination={{
                page: tableFilter.page,
                rowsPerPage: tableFilter.rowsPerPage,
                rowsPerPageOptions: [5, 10, 25],
                handleChangePage: handleChangePage,
                handleChangeRowPerPage: handleChangeRowPerPage,
            }}

            currentFilter={currentFilter}

            pageType={pageType}
            translate={translate}
        />
    )
}